module.exports = __webpack_public_path__ + "static/img/banner1.ce880c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner1.png
// module id = KC9k
// module chunks = 0